import { render, staticRenderFns } from "./warehouseItemContent.vue?vue&type=template&id=5f7bc147&scoped=true&"
import script from "./warehouseItemContent.vue?vue&type=script&lang=js&"
export * from "./warehouseItemContent.vue?vue&type=script&lang=js&"
import style0 from "./warehouseItemContent.vue?vue&type=style&index=0&id=5f7bc147&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7bc147",
  null
  
)

/* custom blocks */
import block0 from "./warehouseItemContent.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports